import { useState, FormEvent } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d70kv5hqa83q0hmd1bn0';
const WHATSAPP_URL = 'https://wa.me/5519988179126';
const INSTAGRAM_URL = 'https://www.instagram.com/turminhadalegriaa/';
const MAP_EMBED = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3675.2!2d-47.0608!3d-22.9556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sRua+Maria+Aparecida+Roqui%2C+177%2C+Parque+Santa+B%C3%A1rbara%2C+Campinas%2C+SP!5e0!3m2!1spt!2sbr!4v1600000000000';

type FormStatus = 'idle' | 'sending' | 'success' | 'error';

export default function Contato() {
  const [status, setStatus] = useState<FormStatus>('idle');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const msg = (form.elements.namedItem('mensagem') as HTMLTextAreaElement)?.value || '';
    if (msg.length > 500) return;

    setStatus('sending');
    const data = new URLSearchParams();
    Array.from(new FormData(form)).forEach(([key, val]) => {
      data.append(key, val as string);
    });

    try {
      await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setStatus('success');
      form.reset();
      setCharCount(0);
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contato" className="py-24 bg-cinza">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-azul-claro/20 text-azul-escuro font-body font-700 text-sm px-4 py-1.5 rounded-full mb-4">
            Entre em Contato
          </span>
          <h4 id="contato-section">
            <a className="font-heading text-[#0D0D0D] text-3xl lg:text-4xl block">
              Fale conosco
            </a>
          </h4>
          <p className="font-body text-gray-500 text-base mt-4 max-w-xl mx-auto">
            Preencha o formulário abaixo ou nos chame diretamente pelo WhatsApp. Estamos prontos para atender sua família!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Form */}
          <div className="bg-white rounded-3xl p-8">
            {status === 'success' ? (
              <div className="text-center py-10">
                <div className="w-16 h-16 flex items-center justify-center bg-azul-claro/20 rounded-full mx-auto mb-4">
                  <i className="ri-check-double-line text-azul-medio text-3xl" />
                </div>
                <h5 className="font-heading text-[#0D0D0D] text-2xl mb-2">Mensagem enviada!</h5>
                <p className="font-body text-gray-500 text-sm">Em breve nossa equipe entrará em contato com você. Obrigado!</p>
                <button
                  onClick={() => setStatus('idle')}
                  className="mt-6 bg-azul-medio text-white font-body font-700 text-sm px-6 py-2.5 rounded-full hover:bg-azul-escuro transition-colors cursor-pointer whitespace-nowrap"
                >
                  Enviar outra mensagem
                </button>
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="space-y-5"
                id="form-contato-turminha"
              >
                <div className="grid sm:grid-cols-2 gap-5">
                  <div>
                    <label className="font-body font-700 text-[#0D0D0D] text-sm block mb-2">
                      Nome do responsável *
                    </label>
                    <input
                      type="text"
                      name="nome_responsavel"
                      required
                      placeholder="Seu nome completo"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 font-body text-sm text-[#0D0D0D] placeholder-gray-400 focus:outline-none focus:border-azul-medio transition-colors"
                    />
                  </div>
                  <div>
                    <label className="font-body font-700 text-[#0D0D0D] text-sm block mb-2">
                      Nome da criança *
                    </label>
                    <input
                      type="text"
                      name="nome_crianca"
                      required
                      placeholder="Nome da criança"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 font-body text-sm text-[#0D0D0D] placeholder-gray-400 focus:outline-none focus:border-azul-medio transition-colors"
                    />
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-5">
                  <div>
                    <label className="font-body font-700 text-[#0D0D0D] text-sm block mb-2">
                      Idade da criança *
                    </label>
                    <input
                      type="text"
                      name="idade_crianca"
                      required
                      placeholder="Ex: 2 anos e 6 meses"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 font-body text-sm text-[#0D0D0D] placeholder-gray-400 focus:outline-none focus:border-azul-medio transition-colors"
                    />
                  </div>
                  <div>
                    <label className="font-body font-700 text-[#0D0D0D] text-sm block mb-2">
                      WhatsApp *
                    </label>
                    <input
                      type="tel"
                      name="whatsapp"
                      required
                      placeholder="(19) 99999-9999"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 font-body text-sm text-[#0D0D0D] placeholder-gray-400 focus:outline-none focus:border-azul-medio transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="font-body font-700 text-[#0D0D0D] text-sm block mb-2">
                    Mensagem
                  </label>
                  <textarea
                    name="mensagem"
                    rows={4}
                    maxLength={500}
                    placeholder="Escreva sua mensagem, dúvida ou solicite uma visita..."
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 font-body text-sm text-[#0D0D0D] placeholder-gray-400 focus:outline-none focus:border-azul-medio transition-colors resize-none"
                  />
                  <p className={`text-xs mt-1 text-right font-body ${charCount >= 500 ? 'text-vermelho' : 'text-gray-400'}`}>
                    {charCount}/500
                  </p>
                </div>

                {status === 'error' && (
                  <p className="font-body text-vermelho text-sm">Erro ao enviar. Tente novamente.</p>
                )}

                <button
                  type="submit"
                  disabled={status === 'sending'}
                  className="w-full bg-azul-escuro text-white font-body font-700 text-base py-4 rounded-xl hover:bg-azul-medio transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {status === 'sending' ? 'Enviando...' : 'Enviar mensagem'}
                </button>
              </form>
            )}
          </div>

          {/* Info */}
          <div className="space-y-6">
            <div className="bg-white rounded-3xl p-6">
              <h5 className="font-heading text-[#0D0D0D] text-xl mb-5">Informações de contato</h5>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-azul-claro/10 rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-2-line text-azul-medio text-xl" />
                  </div>
                  <div>
                    <p className="font-body font-700 text-[#0D0D0D] text-sm">Endereço</p>
                    <p className="font-body text-gray-500 text-sm mt-0.5">
                      Rua Maria Aparecida Roqui, 177<br />
                      Parque Santa Bárbara – Campinas/SP<br />
                      CEP 13064-470
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-vermelho/10 rounded-xl flex-shrink-0">
                    <i className="ri-whatsapp-line text-vermelho text-xl" />
                  </div>
                  <div>
                    <p className="font-body font-700 text-[#0D0D0D] text-sm">WhatsApp</p>
                    <a
                      href={WHATSAPP_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-body text-azul-medio text-sm mt-0.5 hover:text-azul-escuro transition-colors cursor-pointer"
                    >
                      +55 (19) 98817-9126
                    </a>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-azul-escuro/10 rounded-xl flex-shrink-0">
                    <i className="ri-instagram-line text-azul-escuro text-xl" />
                  </div>
                  <div>
                    <p className="font-body font-700 text-[#0D0D0D] text-sm">Instagram</p>
                    <a
                      href={INSTAGRAM_URL}
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="font-body text-azul-medio text-sm mt-0.5 hover:text-azul-escuro transition-colors cursor-pointer"
                    >
                      @turminhadalegriaa
                    </a>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-azul-claro/10 rounded-xl flex-shrink-0">
                    <i className="ri-time-line text-azul-claro text-xl" />
                  </div>
                  <div>
                    <p className="font-body font-700 text-[#0D0D0D] text-sm">Horário de Funcionamento</p>
                    <p className="font-body text-gray-500 text-sm mt-0.5">Segunda a Sexta: 07h00 – 18h00</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-3xl overflow-hidden h-56 w-full">
              <iframe
                src={MAP_EMBED}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização da Escola Infantil Turminha da Alegria em Campinas"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
